import { createContext } from 'react';

import { type GetData } from '@/hooks/useNoodleApi/typings';
import type updateProfile from '@/tsClient/my/updateProfile';

import { type AuthUser, type Profile } from './constants';

export type AuthContextType = {
  isContextInitialized: boolean;
  user: AuthUser | null;
  setUser: (newUser: AuthUser | null) => void;
  profile: Profile | null;
  updateProfile: GetData<typeof updateProfile>;
};

const AuthContext = createContext<AuthContextType>({
  isContextInitialized: false,
  profile: null,
  setUser: () => undefined,
  updateProfile: () => {
    throw new Error('Not in Context');
  },
  user: null,
});

export default AuthContext;
